import { render } from "./FrameParams.vue?vue&type=template&id=27427dfe"
import script from "./FrameParams.vue?vue&type=script&lang=js"
export * from "./FrameParams.vue?vue&type=script&lang=js"

import "./FrameParams.vue?vue&type=style&index=0&id=27427dfe&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTr});
